import type { FC, ReactNode } from 'react'
import type { Fact } from '@/types/content'

import { MessageCircleQuestion } from 'lucide-react'
import { revealDelay } from '@/lib/motion'

interface QuickAnswerProps {
    answer: string
    facts?: Fact[]
    title?: string
}

const QuickAnswer: FC<QuickAnswerProps> = ({ answer, facts, title = "Quick answer" }): ReactNode => {
    return (
        <section aria-labelledby='quick-answer' className='mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8' id='quick-answer-section'>
            <div className='grid gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)]'>
                <div className='rounded-3xl border-2 border-primary/25 bg-white p-6 shadow-sm sm:p-8' data-reveal>
                    <h2 id='quick-answer' className='flex items-center gap-3 text-2xl font-bold'>
                        <MessageCircleQuestion className='size-7 text-primary' aria-hidden='true' />
                        {title}
                    </h2>

                    <p className='mt-4 text-lg leading-relaxed'>
                        {answer}
                    </p>
                </div>

                {facts && facts.length > 0 && (
                    <div className='rounded-3xl bg-sand p-6 sm:p-8' data-reveal style={revealDelay(120)}>
                        <h2 className='text-2xl font-bold'>
                            At a glance
                        </h2>

                        <dl className='mt-4 divide-y divide-border'>
                            {facts.map(fact => (
                                <div key={fact.label} className='grid gap-1 py-3 sm:grid-cols-[10rem_minmax(0,1fr)] sm:gap-4'>
                                    <dt className='font-bold text-navy'>
                                        {fact.label}
                                    </dt>

                                    <dd>
                                        {fact.value}
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                )}
            </div>
        </section>
    )
}

export default QuickAnswer
